import { getSearchConfig } from "@/components/dynamic-form/helper/getSearchConfig";
import { SearchBarType } from "@/components/dynamic-form/constants";
import { useTranslation } from "react-i18next";
import { useAccountOptions } from "@/pages/consumption/hooks/useAccountOptions";
import { usePlatformOptions } from "@/pages/consumption/hooks/usePlatformOptions";
import { useProjectOptions } from "@/pages/consumption/hooks/useProjectOptions";
import { getToday, ONE_WEEK } from "@/utils/date-formatter/getToday";
import dayjs from "project-config/utils/dayjs";

export function useSearchConfig() {
  const { t } = useTranslation("center");

  const accountOptions = useAccountOptions();
  const platformOptions = usePlatformOptions();
  const projectOptions = useProjectOptions(true);

  const searchConfig = getSearchConfig(() => {
    const now = getToday();
    const weekAgo = new Date(now.getTime() - ONE_WEEK);

    const allOptionItem = {
      value: -1,
      label: t("custom_display_text_all"),
    };

    return [
      {
        type: SearchBarType.Select,
        field: "userId",
        label: t("record_header_account"),
        props: {
          defaultValue: -1,
          allowClear: false,
          options: [allOptionItem, ...accountOptions],
        },
      },
      {
        type: SearchBarType.Select,
        field: "platform",
        label: t("user_consume_pick_platform"),
        props: {
          defaultValue: -1,
          allowClear: false,
          options: [allOptionItem, ...platformOptions],
        },
      },
      {
        type: SearchBarType.Select,
        field: "projectId",
        label: t("render_table_sort_projectName"),
        props: {
          allowClear: false,
          defaultValue: -1,
          options: [allOptionItem, ...projectOptions],
        },
      },
      {
        type: SearchBarType.Select,
        field: "timeStatus",
        label: t("render_table_sort_datetype"),
        props: {
          allowClear: false,
          defaultValue: 1,
          options: [
            {
              value: 0,
              label: t("user_consume_pick_time_status_submit"),
            },
            {
              value: 1,
              label: t("user_consume_pick_time_status_end"),
            },
            {
              value: 3,
              label: t("user_consume_pick_frame_start_time"),
            },
            {
              value: 4,
              label: t("user_consume_pick_frame_end_time"),
            },
          ],
        },
      },
      {
        type: SearchBarType.DatePicker,
        field: "time",
        label: t("user_consume_pick_date"),
        limitMonthNum: 3,
        isTrendsChangeDate: true,
        props: {
          allowClear: false,
          defaultValue: [dayjs(weekAgo), dayjs(now)],
        },
      },
    ];
  });

  return { searchConfig };
}
